import spain from './spain.svg';
import other from './other.svg';

export const ES = { src: spain, alt: 'Spain' };
export const XX = { src: other, alt: 'Some other country' };
